<template>
<div class="chapter">
<div class="inner_page">
<a id="page_4">
<h4 class="subc"><span class="bold">Irgun Anthem</span></h4>
<p class="center">Tagar –</p>
<p class="center">Through all obstacles and enemies</p>
<p class="center">Whether you go up or down</p>
<p class="center">In the flames of revolt</p>
<p class="center">Carry a flame to kindle—never mind!</p>
<p class="center">For silence is filth</p>
<p class="center">Worthless is blood and soul</p>
<p class="center">For the sake of the hidden glory</p>
<p class="center">To die or to conquer the hill –</p>
<p class="center">Yodefet, Masada, Betar</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Irgunanthem.vue?d4532376